import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router';
import { Icon } from '@/components/Icon';
import type { SidebarView } from '@/components/ViewSidebar';
import s from './InventoryViewPopover.module.css';

/** iPad L1b：桌面的库存视图栏收进标题下拉，切换时保留原有路由与权限。 */
export function InventoryViewPopover({ title, count, views, active, onPick }: {
  title: string; count?: number; views: SidebarView[]; active: string; onPick: (key: string) => void;
}) {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const outside = (event: PointerEvent) => {
      if (!ref.current?.contains(event.target as Node)) setOpen(false);
    };
    const escape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') setOpen(false);
    };
    document.addEventListener('pointerdown', outside);
    document.addEventListener('keydown', escape);
    return () => { document.removeEventListener('pointerdown', outside); document.removeEventListener('keydown', escape); };
  }, [open]);

  return <div className={s.anchor} ref={ref}>
    <button type="button" className={s.trigger} aria-expanded={open} aria-haspopup="menu" onClick={() => setOpen((value) => !value)}>
      <span>{title}</span>{count !== undefined && <small className="tnum">{count}</small>}<Icon name="chevd" size={18} />
    </button>
    {open && <nav className={s.pop} aria-label="库存视图" role="menu">
      <div className={s.heading}>库存视图</div>
      {views.map((item) => {
        const content = <><Icon name={item.icon} size={16} /><span>{item.label}</span>{item.count !== undefined && <i className={`${s.count} ${item.hot ? s.hot : ''} tnum`}>{item.count}</i>}</>;
        return <div key={item.key}>
          {item.separator && <div className={s.sep} />}
          {item.to ? <Link className={`${s.item} ${active === item.key ? s.on : ''}`} role="menuitem" to={item.to} onClick={() => setOpen(false)}>{content}</Link>
            : <button type="button" className={`${s.item} ${active === item.key ? s.on : ''}`} role="menuitem" disabled={!!item.disabledReason} title={item.disabledReason} onClick={() => { onPick(item.key); setOpen(false); }}>{content}</button>}
        </div>;
      })}
    </nav>}
  </div>;
}
